import searchBar from './searchBar';
export default searchBar;



// WEBPACK FOOTER //
// ./src/components/searchBar/index.js